import { t } from '@lingui/macro';
import { object, string } from 'yup';
const makeSchema = () => object().shape({
    name: string().required(t({ message: 'Name is required', comment: 'Validation message for name field' })),
});
export const schema = makeSchema();
